module.exports = __webpack_public_path__ + "img/build_wheel@2x.807e86f3.jpg";